
import React, { PureComponent } from 'react';
import _ from "lodash";
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {withStyles} from "@material-ui/core/styles";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import Transition from './Transition';

const styles = () => ({
	dialogPaper: {
		overflow: 'scroll',
		maxWidth : '100%',
		width: 800,
		height : '95%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	pageImage : {
		width : '100%',
		//height : '100%',
		border : '1px solid #888',
		marginLeft : 10,
	},
	pricingDescription : {
		border : '1px solid #eee',
		padding : 20,
		marginBottom : 40,
	}
});

class ResourcePopup extends PureComponent {
	/*
	constructor (props) {
		super(props);
	}
	*/

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const {classes, fuelContract, fullScreen } = this.props;

		if (_.isEmpty(fuelContract)) {
			return null;
		}

		return (
			<div>
				<Dialog
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
					fullScreen={fullScreen}
					maxWidth='lg'
					classes={{
						paper: classes.dialogPaper
					}}
				>
					<DialogTitle>
						<div style={{alignItems : 'center', display : 'flex', justifyContent: 'space-between'}}>
							<Button onClick={this.handleClose}>Close</Button>
						</div>
					</DialogTitle>
					<DialogContent style={{height:'100%', paddingLeft : 40, paddingRight : 40}}>

						<div>Provisional Pricing Description</div>
						<div className={classes.pricingDescription}>
							{fuelContract.provisionalPricing}
						</div>

						<div>Final Pricing Description</div>
						<div className={classes.pricingDescription}>
							{fuelContract.finalPricing}
						</div>

					</DialogContent>
				</Dialog>
			</div>
		);
	}
}

ResourcePopup.propTypes = {
	fuelContract : PropTypes.object,
	open : PropTypes.bool,
	onClose : PropTypes.func,
	fullScreen: PropTypes.bool.isRequired,
	classes : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(ResourcePopup);
